<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Дилеры</h3>
		</header>
		<p class="text-center">
			<img src="//iwstatic.g.bsrv.su/img/wiki/monetadilers.jpg" width="150" height="150" />
		</p>
		<p><b>Дилер</b> - игрок, который имеет право продавать специальную <router-link to="/wiki/opis_econom1">игровую валюту</router-link>, а также другие игровые возможности.</p>
		<p>Список официальных дилеров:
			<ul>
				<li>дилеров нет</li>
			</ul>
		</p>
		<p>Обращаем Ваше внимание на то, что Администрация контролирует работу Дилеров и гарантирует, что заказанные услуги будут доступны Вам для пользования в течении 6 часов с момента оплаты.</p>
		<p>Жалобы, вопросы и предложения просим писать на <a href="mailto:support-games@bylex.com">support-games@bylex.com</a>.</p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiDilers',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>